// extracted by mini-css-extract-plugin
export var cookiesSection = "fd_Kh";
export var cookiesSection__btn = "fd_Kl";
export var cookiesSection__link = "fd_Kk";
export var cookiesSection__text = "fd_Kj";
export var cookiesSection__wrapper = "fd_Kg";